import './FooterLayout.css';
export default {
    "footerContainer": "FooterLayout_footerContainer__18c0f",
    "footerItem": "FooterLayout_footerItem__18c0f",
    "signalIcon": "FooterLayout_signalIcon__18c0f",
    "signalText": "FooterLayout_signalText__18c0f"
};
